import type { PurchaseOrder } from '@/types/purchaseOrders';

// Display order for the per-type figures — the same order the board's type rows use.
const TYPE_ORDER = ['LC', 'MMC', 'MPO'];

function typeRank(code: string): number {
  const index = TYPE_ORDER.indexOf(code);
  return index === -1 ? TYPE_ORDER.length : index;
}

export function queueTotals(items: PurchaseOrder[]): { byType: Record<string, number>; unknownCount: number } {
  const byType: Record<string, number> = {};
  let unknownCount = 0;
  items.forEach((po) => {
    if (po.remainingTotals === null) {
      unknownCount += 1;
      return;
    }
    Object.entries(po.remainingTotals).forEach(([code, remaining]) => {
      if (remaining > 0) byType[code] = (byType[code] ?? 0) + remaining;
    });
  });
  return { byType, unknownCount };
}

export function remainingLine(po: PurchaseOrder): string {
  if (po.remainingTotals === null) return 'remaining not computable';
  return Object.entries(po.remainingTotals)
    .filter(([, remaining]) => remaining > 0)
    .sort(([a], [b]) => typeRank(a) - typeRank(b))
    .map(([code, remaining]) => `${code} ${remaining.toLocaleString()}`)
    .join(' · ');
}

export function isPartiallyScheduled(po: PurchaseOrder): boolean {
  return po.assignments.length > 0;
}

// The viewer's local day, so the queue and the schedule dialog show the same date for one mark.
export function markedOnLabel(markedAt: string): string {
  return new Date(markedAt).toLocaleDateString(undefined, { month: 'short', day: 'numeric', year: 'numeric' });
}
